"use client";

import * as React from "react";
import { useAuthSession } from "@/lib/use-auth-session";

export default function Home() {
  const { mounted, isAuthed } = useAuthSession();

  React.useEffect(() => {
    if (!mounted) return;
    window.location.replace(isAuthed ? "/dashboard" : "/login");
  }, [isAuthed, mounted]);

  if (!mounted) return null;

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="panel rounded-2xl px-6 py-5 text-sm text-[var(--muted)]">
        Redirecting...
      </div>
    </div>
  );
}
